import EngageRequest from '../EngageRequest';
import { $stateParams } from '../../router';

export const SessionIsClosed = (sessionId) => {
    const accountUuid = $stateParams.account_uuid;
    const contactUuid = $stateParams.contact_uuid;
    const eventId     = $stateParams.event_id;

    if (!accountUuid || !contactUuid || !eventId || !sessionId) return Promise.reject();

    return EngageRequest.get(`/rsvp/${accountUuid}/${contactUuid}/${eventId}/session/${sessionId}`)
        .then(({session}) => session.closed);
};

export default SessionIsClosed;